import { roundDurationToMinutes } from '../helpers/round-duration-to-minutes';
import { useDurationSince } from '../hooks/use-duration-since';

// Sized relative to the surrounding text so the duration scales with it (e.g. queue density)
const UnitText = ({ children }: { children: React.ReactNode }) => (
    <span style={{ fontSize: '0.8em' }}>{children}</span>
);

export function FormattedDurationSinceDetailed({
    date,
    signal,
}: {
    date: Date;
    signal?: unknown;
}): React.ReactElement {
    // The duration refreshes on a timer, so it can lag a unit timer by a few seconds. The minutes
    // round up after 55 seconds to make up for it.
    const duration = roundDurationToMinutes(useDurationSince({ date, signal, interval: 10000 }));

    // display all time units up to the highest populated unit
    const months = duration.months || duration.years ? duration.months : undefined;
    const days = duration.days || months !== undefined ? duration.days : undefined;
    const hours = duration.hours || days !== undefined ? duration.hours : undefined;
    return (
        <span>
            {duration.years ? (
                <>
                    {duration.years}
                    <UnitText>Y</UnitText>
                </>
            ) : null}
            {months !== undefined ? (
                <>
                    {duration.years ? ' ' : ''}
                    {months}
                    <UnitText>M</UnitText>
                </>
            ) : null}
            {days !== undefined ? (
                <>
                    {duration.years || duration.months ? ' ' : ''}
                    {days}
                    <UnitText>D</UnitText>
                </>
            ) : null}
            {hours !== undefined ? (
                <>
                    {duration.years || duration.months || duration.days ? ' ' : ''}
                    {hours}
                    <UnitText>H</UnitText>
                </>
            ) : null}
            {hours !== undefined ? ' ' : ''}
            {duration.minutes}
            <UnitText>M</UnitText>
        </span>
    );
}
